var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TitleField',{attrs:{"fieldName":_vm.FieldName.MRPA_BASE_AUTHORITY}}),_c('div',{staticClass:"row-box"},_vm._l((_vm.orderedData),function(fieldValue,fieldName){return _c('WrapperField',{key:fieldValue + fieldName + Math.random(),attrs:{"data":_vm.createDataField({
          fieldName: fieldName,
          fieldValue: fieldValue,
          fieldGroup: _vm.FieldGroup.MRPA_BASE_AUTHORITY,
        })}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }